module.exports = __webpack_public_path__ + "static/img/swiper1_1.01467ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/customLogin/swiper1_1.jpg
// module id = /yXD
// module chunks = 16